import {
  SurveyAnswerCreateRequest,
  SurveyCloseRequest,
  SurveyCreateRequest,
  SurveyDeleteRequest,
  SurveyGetRequest,
  SurveyJoinRequest,
  SurveyLeaveRequest,
  SurveyUpdateRequest
} from "@kalyzee/kast-web-sdk/websocket";
import { createAction } from "@reduxjs/toolkit";

const ACTION_PREFIX = "socket_survey_";

const socketSurveyActions = {
  // Create :
  create: createAction<SurveyCreateRequest>(`${ACTION_PREFIX}create`),
  createAnswer: createAction<SurveyAnswerCreateRequest>(`${ACTION_PREFIX}create_answer`),
  // Read :
  get: createAction<SurveyGetRequest>(`${ACTION_PREFIX}get`),
  // Update :
  update: createAction<SurveyUpdateRequest>(`${ACTION_PREFIX}update`),
  // Delete :
  delete: createAction<SurveyDeleteRequest>(`${ACTION_PREFIX}delete`),
  // Join :
  join: createAction<SurveyJoinRequest>(`${ACTION_PREFIX}join`),
  // Leave :
  leave: createAction<SurveyLeaveRequest>(`${ACTION_PREFIX}leave`),
  // Close :
  close: createAction<SurveyCloseRequest>(`${ACTION_PREFIX}close`),
};

export default socketSurveyActions;
